import { jsx as _jsx } from "react/jsx-runtime";
import { HcModal } from '@hotmart-org-ca/cosmos-web/dist/react/hc-modal';
import { useTranslation } from 'react-i18next';
import { ModalBody } from './body';
import { ModalFooter } from './footer';
import { ModalHeader } from './header';
export function Modal({ opened, children, dismissible, onOpenModal, onCloseModal, backdropDismissible = false }) {
    const { t } = useTranslation();
    return (_jsx(HcModal, { mobileFull: true, role: "dialog", opened: opened, dismissible: dismissible, className: "cursor-default", onOpenModal: onOpenModal, onCloseModal: onCloseModal, backdropDismissible: backdropDismissible, dismissButtonAriaLabel: t('general.close'), children: opened && children }));
}
Modal.Body = ModalBody;
Modal.Header = ModalHeader;
Modal.Footer = ModalFooter;
